<template>
  <div id="home">
    <!-- 轮播图 -->
    <el-carousel class="topBanner" height="800px">
      <el-carousel-item v-for="item in TopbannerList" :key="item.id">
        <img :src="item.url" alt>
      </el-carousel-item>
    </el-carousel>
    <div class="text inner">
      <p>主营业务</p>
      <p>&mdash;&nbsp;main business&nbsp;&mdash;</p>
    </div>
    <el-carousel class="bottBanner inner" height="530px" indicator-position="outside">
      <el-carousel-item v-for="item in bottBannerList" :key="item.id">
        <img :src="item.url" alt>
      </el-carousel-item>
    </el-carousel>
    <el-row class="abundant">
      <el-col :span="6" v-for="item in abundantList" :key="item.id">
        <div class="grid-content" @mouseover="mouseOver(item.id)" @mouseleave="mouseLeave(item.id)" :style="{ 'background-image': 'url(' + item.backgroundUrl + ')'}">
          <div id="overlay"></div>
          <img ref="abundantImg" :src="item.url" alt="">
          <p>{{item.tit}}</p>
          <p>{{item.content}}</p>
        </div>
      </el-col>
    </el-row>
    <div class="text inner">
      <p>近期活动</p>
      <p>&mdash;&nbsp;main business&nbsp;&mdash;</p>
    </div>
    <div class="machine inner">
      <div class="bg-purple" v-for="item in machineList" :key="item.id">
        <img :src="item.url" alt="">
        <p>{{item.tit}}</p>
        <p>{{item.content}}</p>
        <p>{{item.activity}}</p>
      </div>
    </div>
    <div class="consult inner">
      <div class="consulTop">
        <p><span>Industry information</span><br><span>行业咨询</span></p>
      </div>
      <div class="consulBottom">
        <div>
          <img src="@/assets/consult/1.png" alt="">
          <div class="consulBottomTxt">
            <div class="fl"><span>01</span><br><span>五月</span></div>
            <div class="fl">
              <p>系统不能用？临时升级凌晨3点完成， 现正常运行</p>
              <p>受“国庆期间护网行动“的政策影响，人证 实名认证，OCR证照识别，人实名认证，O CR证照识别实名认证，OCR识别...</p>
              <p>查看更多></p>
            </div>
          </div>
        </div>
        <div>
          <img src="@/assets/consult/2.png" alt="">
          <div class="consulBottomTxt">
            <div class="fl"><span>01</span><br><span>五月</span></div>
            <div class="fl">
              <p>系统不能用？临时升级凌晨3点完成， 现正常运行</p>
              <p>受“国庆期间护网行动“的政策影响，人证 实名认证，OCR证照识别，人实名认证，O CR证照识别实名认证，OCR识别...</p>
              <p>查看更多></p>
            </div>
          </div>
        </div>
        <div>
          <img src="@/assets/consult/3.png" alt="">
          <div class="consulBottomTxt">
            <div class="fl"><span>01</span><br><span>五月</span></div>
            <div class="fl">
              <p>系统不能用？临时升级凌晨3点完成， 现正常运行</p>
              <p>受“国庆期间护网行动“的政策影响，人证 实名认证，OCR证照识别，人实名认证，O CR证照识别实名认证，OCR识别...</p>
              <p>查看更多></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text inner">
      <p>近期活动</p>
      <p>&mdash;&nbsp;Recent activities&nbsp;&mdash;</p>
    </div>
    <div class="publicity">
      <!-- 宣传视频 -->
      <p>企业产品宣传视频</p>
      <p>Enterprise Product Promotion Video</p>
      <p @click="click_video">宣传 视频</p>
    </div>
    <div class="text inner">
      <p>合作客户</p>
      <p>&mdash;&nbsp;Cooperative customers&nbsp;&mdash;</p>
    </div>
    <div class="cooperation inner">
      <img src="@/assets/home/HD.png" alt="">
      <img src="@/assets/home/TX.png" alt="">
      <img src="@/assets/home/WD.png" alt="">
      <img src="@/assets/home/ZG.png" alt="">
      <img src="@/assets/home/ZGHT.png" alt="">
      <img src="@/assets/home/ZGJT.png" alt="">
      <img src="@/assets/home/ZGPA.png" alt="">
      <img src="@/assets/home/ZGYH.png" alt="">
    </div>
    <div class="leaveWord">
      <div class="inner">
        <div>
          <el-input style="width: 470px;" type="textarea" placeholder="留言内容" v-model="textarea" resize="none" :rows="11" maxlength="600" show-word-limit>
          </el-input>
        </div>
        <div class="leaveWordRifht">
          <p class="tit"><span>Question feedback</span><br><span>问题反馈</span></p>
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-row>
              <el-form-item>
                <el-input clear="inp" v-model="formInline.user" style="width: 400px;" placeholder="联系邮箱"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="danger" class="btn" icon="el-icon-position" @click="onSubmit"></el-button>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item>
                <el-input v-model="code" style="width: 400px;" placeholder="验证码"></el-input>
              </el-form-item>
              <el-form-item>
                <div class="login-code" @click="refreshCode">
                  <!--验证码组件-->
                  <s-identify :identifyCode="identifyCode"></s-identify>
                </div>
              </el-form-item>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <footerPage></footerPage>
  </div>
</template>
<script>
import '@/css/home.css'
import '@/css/public.css'
import footerPage from '../components/Footer'
import SIdentify from '../components/sidentify'
export default {
  components: {
    footerPage,
    SIdentify
  },
  data() {
    return {
      identifyCodes: "1234567890",
      identifyCode: "",
      code: "",//text框输入的验证码
      formInline: {
        user: '',
        region: ''
      },
      textarea: '',
      machineList: [
        {
          id: 1, url: require("@/assets/home/DZ2010AC.png"), tit: '东芝2010AC', content: '新购机免费赠送4万印黑白印张服务',
          activity: '全新机促销活动'
        },
        {
          id: 2, url: require("@/assets/home/KMC364e.png"), tit: '柯美C364E', content: '新购机赠送原装大容量墨粉一支',
          activity: '再制造促销活动'
        }
      ],
      abundantList: [
        { id: 0, url: require("@/assets/home/experience1.png"), backgroundUrl: require("@/assets/home/abundant1.png"), tit: '丰富经验', content: '专注行业12年，涉及80多个行业，服务超过90000多个客户，完善的售前-售中-售后定制服务，让您的印刷品变成艺术品。' },
        { id: 1, url: require("@/assets/home/programme1.png"), backgroundUrl: require("@/assets/home/abundant2.png"), tit: '解决方案', content: '拥有全世界先进的生产设备，为广大客户量身定制方案，一站式贴心服务，帮助您解决办公设备问题，让您没有后顾之忧。' },
        { id: 2, url: require("@/assets/home/team1.png"), backgroundUrl: require("@/assets/home/abundant3.png"), tit: '优秀团队', content: '拥有200多人的团队，集创意，设计，成品一体，结合国内外更新的技术和工艺，精益求精，做到不仅让客户满意，更要让客户感动。' },
        { id: 3, url: require("@/assets/home/Administration1.png"), backgroundUrl: require("@/assets/home/abundant4.png"), tit: '软件管理', content: '提供包括耗材销售、设备租赁、IT运营外包在内的服务。协助客户进行办公系统的集中管理与控制，降低办公成本、提升核心竞争力。' },
      ],
      TopbannerList: [
        { id: 1, url: require("@/assets/home/TOPbanner.png") }
      ],
      bottBannerList: [
        { id: 1, url: require("@/assets/home/banner1.png") },
        { id: 2, url: require("@/assets/home/banner2.png") },
        { id: 4, url: require("@/assets/home/banner3.png") }
      ]
    };
  },
  created() {
    this.refreshCode()
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 5);
  },
  methods: {
    //验证码
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 5);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    onSubmit() {
      if (this.code === '') {
        this.$message({ message: '请输入验证码', type: 'warning' })
        return
      }
      if (this.identifyCode != this.code) {
        this.code = ''
        this.refreshCode()
        this.$message({ message: '请输入正确的验证码', type: 'warning' })
        return
      }
      this.$message({ message: '提交成功', type: 'success' })
      this.refreshCode()
      this.code = ''
      this.formInline.user = ''
      this.textarea = ''

    },
    click_video() {
      this.$router.push('/Video');
    },
    // 移入
    mouseOver(id) {
      switch (id) {
        case 0:
          this.$refs.abundantImg[id].src = require("@/assets/home/experience.png")
          break
        case 1:
          this.$refs.abundantImg[id].src = require("@/assets/home/programme.png")
          break
        case 2:
          this.$refs.abundantImg[id].src = require("@/assets/home/team.png")
          break
        default:
          this.$refs.abundantImg[id].src = require("@/assets/home/Administration.png")
          break
      }
    },
    // 移出
    mouseLeave(id) {
      switch (id) {
        case 0:
          this.$refs.abundantImg[id].src = require("@/assets/home/experience1.png")
          break
        case 1:
          this.$refs.abundantImg[id].src = require("@/assets/home/programme1.png")
          break
        case 2:
          this.$refs.abundantImg[id].src = require("@/assets/home/team1.png")
          break
        default:
          this.$refs.abundantImg[id].src = require("@/assets/home/Administration1.png")
          break
      }
    }
  }
};
</script>

